import { parsePositiveInteger } from '@iconik-io/core/src/parse_positive_integer';
import { FLAG_SEARCH_INFINITE_SCROLL } from '@iconik-io/shared-lib/src/analytics/flags';
import { growthbook } from '@iconik-io/shared-lib/src/analytics/growthbook';
import type { CommonListGetConfig } from '@iconik-io/shared-lib/src/redux/common_list/thunks';
import { getQueryPerPage } from '@iconik-io/shared-lib/src/utils/url/get_query_per_page';

import { PAGE_SIZE_ITEM } from '../../../constants/local_storage';
import { INFINITE_SCROLL_PAGE_SIZE } from '../../../constants/page_size';
import { SHARE_COLLECTION_PAGE_ROUTE } from '../../../constants/routes';
import type { AppState } from '../../../store/types';
import {
  selectCanPageNaturalSearch,
  selectIsNaturalSearchActive,
} from '../../natural_search/selectors';

export const isSearchInfiniteScrollOn = (): boolean =>
  growthbook?.isOn(FLAG_SEARCH_INFINITE_SCROLL) ?? false;

export const getSearchPerPage = (search: string): number => {
  if (!isSearchInfiniteScrollOn()) {
    return getQueryPerPage(search, PAGE_SIZE_ITEM);
  }
  const queryPerPage = new URLSearchParams(search).get('per_page');
  return parsePositiveInteger(queryPerPage) ?? INFINITE_SCROLL_PAGE_SIZE;
};

export const selectSearchPerPage = (state: AppState): number =>
  getSearchPerPage(state.router.location.search);

export const selectSearchPaginationType = (
  state: AppState,
): CommonListGetConfig['paginationType'] => {
  if (!isSearchInfiniteScrollOn()) {
    return 'regular';
  }
  // A natural answer's next page is a replay of it, asked for by number. One
  // that cannot page is the one page it answered with.
  if (selectIsNaturalSearchActive(state)) {
    return selectCanPageNaturalSearch(state) ? 'infinite' : 'regular';
  }
  return state.routeParams.route === SHARE_COLLECTION_PAGE_ROUTE
    ? 'infinite'
    : 'cursor';
};

export const selectIsSearchPagedByNumber = (state: AppState): boolean =>
  selectSearchPaginationType(state) === 'regular';
